// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.059 1L20.9614 20.2076L12.0002 23.568L3.03898 20.2076L1.94141 1H22.059ZM6.26746 15.4632L6.26764 15.4665L6.38163 17.4612L11.9998 19.568L17.6179 17.4612L18.0227 10.3768L10.9321 10.3768L18.2221 6.88688L18.33 5H5.48242L5.74635 7.01163L12.0007 7H13.3541L5.98542 10.5276L6.09109 12.3768L15.9052 12.3768L15.6955 16.0461L11.9998 17.432L8.30403 16.0461L8.26464 15.3568L8.20278 14.0734H6.19261L6.26746 15.4632Z"}}]};

const Css3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'css3-filled',
    ref,
    icon: element,
  },
));

Css3FilledIcon.displayName = 'Css3FilledIcon';

export default Css3FilledIcon;
